import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SearchButton } from "../SearchBox/SearchButton";
import { Button } from "react-bootstrap";
import { useNavigationActions } from "../../hooks/useNavigationActions";

export const BottomNav = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const { triggerAddBookmark } = useNavigationActions();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bottom-nav position-fixed d-flex justify-content-between align-items-center start-0 end-0 bottom-0 px-3 pt-2 bg-body shadow-sm border-top z-3">
      <Link
        to="/"
        className={`nav-item text-decoration-none d-flex flex-column justify-content-center nav-item text-center ${
          isActive("/") ? "active" : "text-secondary"
        }`}
      >
        <i
          className={`bi bi-bookmarks${
            isActive("/") ? "-fill" : " text-secondary"
          } fs-2`}
        ></i>
        <span className="small">{t("sidebar.menu.bookmarks")}</span>
      </Link>

      <Link
        to="/collections"
        className={`nav-item text-decoration-none d-flex flex-column justify-content-center nav-item text-center ${
          isActive("/collections") ? "active" : "text-secondary"
        }`}
      >
        <i
          className={`bi bi-collection${
            isActive("/collections") ? "-fill" : " text-secondary"
          } fs-2`}
        ></i>
        <span className="small">{t("sidebar.menu.collectionsShort")}</span>
      </Link>

      <Button
        variant="none"
        onClick={triggerAddBookmark}
        className={`nav-add p-0`}
      >
        <div className="add-button bg-primary text-white d-flex justify-content-center align-items-center icon icon-lx shadow">
          <i className="bi bi-plus"></i>
        </div>
      </Button>

      <SearchButton />

      <Link
        to="/settings"
        className={`nav-item text-decoration-none d-flex flex-column justify-content-center nav-item text-center ${
          isActive("/settings") ? "active" : "text-secondary"
        }`}
      >
        <i
          className={`bi bi-person${
            isActive("/settings") ? "-fill" : " text-secondary"
          } fs-2`}
        ></i>
        <span className="small">{t("sidebar.menu.settings.title")}</span>
      </Link>
    </nav>
  );
};
